import(/* webpackMode: "eager" */ "/opt/eop-platform/apps/crewpass37/apps/web/src/app/global-error.tsx");
